import { Card, mergeSxProps, Text } from "@clipboard-health/ui-components";
import {
  CardActionArea,
  CardContent,
  Skeleton,
  Stack,
  type SxProps,
  type Theme,
} from "@mui/material";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_NC_ORIENTATION_PATH } from "../paths";
import { useShiftModalsDataContext } from "../useShiftModalsDataContext";
import { useNCOrientationStatus } from "./useNCOrientationStatus";

interface NCOrientationShiftDetailsCardProps {
  sx?: SxProps<Theme>;
}

export function NCOrientationShiftDetailsCard(props: NCOrientationShiftDetailsCardProps) {
  const { sx } = props;
  const history = useHistory();
  const { baseNavigationPath } = useShiftModalsDataContext();
  const { shouldShow, isLoading } = useNCOrientationStatus();

  if (isLoading) {
    return <Skeleton variant="rounded" height={100} sx={mergeSxProps({ borderRadius: 3 }, sx)} />;
  }

  if (!shouldShow) {
    return null;
  }

  return (
    <Card outlined variant="quaternary" sx={sx}>
      <CardActionArea
        onClick={() => {
          history.push(`${baseNavigationPath}/${SHIFT_DISCOVERY_NC_ORIENTATION_PATH}`);
        }}
      >
        <CardContent>
          <Stack spacing={2}>
            <Text semibold variant="h6">
              North Carolina Orientation
            </Text>
            <Text
              variant="body2"
              sx={(theme) => ({
                color: theme.palette.text?.secondary,
              })}
            >
              You must complete this orientation before booking shifts in North Carolina.
            </Text>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
